import BaseEvent, {
  BaseGetEvent,
  IBaseEvent,
} from 'hooks/context/EventCollector/events/BaseEvent';

export interface IButtonEvent extends IBaseEvent {
  type: 'button';
  toJSON(): BaseGetEvent & {
    type: IButtonEvent['type'];
    content: string;
  };
}

export default class ButtonEvent extends BaseEvent implements IButtonEvent {
  type = 'button' as const;

  private content: string;

  constructor({
    description,
    content,
  }: {
    description: string;
    content: string;
  }) {
    super(description);
    this.content = content;
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      content: this.content,
    };
  }
}
